import isEmpty from 'lodash/isEmpty';
export function copyProp (src, dest, srcField, destField = null, defaultValue = null) {
    const fld = destField ?? srcField;
    if (src !== undefined && src[srcField] !== undefined && src[srcField] !== null) {
        dest[fld] = src[srcField];
    } else if (defaultValue !== null) {
        dest[fld] = defaultValue;
    }
}

export function removeFalsy (data, field) {
    if (data[field] && isEmpty(data[field])) {
        delete data[field];
    }
}

export function removeBooleanFalsy (data, field) {
    if (data[field] === false) {
        delete data[field];
    }
}
